<template>
  <div class="findpass-box">
    <common>
      <span class="title">找回密码</span>
      <a-form
        ref="form"
        :autoFormCreate="(form)=>{this.form = form}"
        id="form"
        :wrapper-col="{ span: 12,offset: 12 }"
      >
        <a-form-item
          v-if="showTenant"
          fieldDecoratorId="tenantName"
          :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入租户名', whitespace: true}]}"
        >
          <a-input size="large" placeholder="请输入租户名">
            <a-icon slot="prefix" type="idcard"></a-icon>
          </a-input>
        </a-form-item>
        <a-form-item
          fieldDecoratorId="username"
          :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入账户名'}]}"
        >
          <a-input size="large" placeholder="请输入账户名">
            <a-icon slot="prefix" type="user"></a-icon>
          </a-input>
        </a-form-item>
        <!-- <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
        <template slot="content">
          <div :style="{ width: '240px' }">
            <div :class="['pass-leval', passwordLevelClass]">
              强度：
              <span>{{ passwordLevelName }}</span>
            </div>
            <a-progress
              :percent="state.percent"
              :showInfo="false"
              :strokeColor=" passwordLevelColor "
            />
            <div style="margin-top: 10px;">
              <span>请至少输入 6 位非单一数字或字符的密码。</span>
            </div>
          </div>
        </template>
        <a-form-item
          fieldDecoratorId="password"
          :fieldDecoratorOptions="{rules: [{ required: true, message: '至少6位密码'}, { validator: this.handlePasswordLevel },{min:6,message: '至少6位密码'}], validateTrigger: ['change', 'blur']}"
        >
          <a-input
            size="large"
            type="password"
            @click="handlePasswordInputClick"
            autocomplete="false"
            placeholder="请输入至少6位密码"
          >
            <a-icon slot="prefix" type="lock"></a-icon>
          </a-input>
        </a-form-item>
        </a-popover>-->

        <!-- <a-form-item
        fieldDecoratorId="password2"
        :fieldDecoratorOptions="{rules: [{ required: true, message: '至少6位密码' }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur']}"
      >
        <a-input size="large" type="password" autocomplete="false" placeholder="确认密码">
          <a-icon slot="prefix" type="lock"></a-icon>
        </a-input>
        </a-form-item>-->

        <a-form-item
          fieldDecoratorId="mobile"
          :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入正确的手机号', pattern: /^1[3456789]\d{9}$/ }], validateTrigger: ['change', 'blur'] }"
        >
          <a-input size="large" placeholder="请输入手机号">
            <a-icon slot="prefix" type="mobile"></a-icon>
          </a-input>
        </a-form-item>
        <div class="vecode-box">
          <a-form-item
            fieldDecoratorId="vrcode"
            :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}"
          >
            <a-input size="large" type="text" placeholder="输入验证码">
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>
          <div class="btn-box">
            <a-button
              size="large"
              :disabled="state.smsSendBtn"
              @click.stop.prevent="getCaptcha"
              v-text="!state.smsSendBtn && '获取验证码'||(state.time+' s')"
            ></a-button>
          </div>
        </div>
        <div class="foot-btn">
          <a-button class="commitbtn" block size="large" @click.stop.prevent="handleSubmit">确认</a-button>
          <a-button class="canceltbtn" block size="large" @click="returnLogin">取消</a-button>
        </div>
      </a-form>
    </common>
  </div>
</template>

<script>
const levelNames = {
  0: "低",
  1: "低",
  2: "中",
  3: "强"
};
const levelClass = {
  0: "error",
  1: "error",
  2: "warning",
  3: "success"
};
const levelColor = {
  0: "#ff0000",
  1: "#ff0000",
  2: "#ff7e05",
  3: "#52c41a"
};
import { loginParamId } from "@/router/index.js";
import common from "../common/LoginComm";
import { mapMutations } from "vuex";
export default {
  components: {
    common
  },
  data() {
    return {
      form: null,
      showTenant: true,
      interval: null,
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: "#FF0000"
      },
      registerBtn: false
    };
  },
  computed: {
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel];
    },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel];
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel];
    }
  },
  methods: {
    ...mapMutations({
      setUserName: "findpassword/setUserName",
      setVerificationCode: "findpassword/setVerificationCode",
      setTenantName: "findpassword/setTenantName"
    }),

    isMobile() {
      return this.$store.state.setting.isMobile;
    },
    handlePasswordLevel(rule, value, callback) {
      let level = 0;
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++;
      }
      this.state.passwordLevel = level;
      this.state.percent = level * 30;
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100;
        }
        callback();
      } else {
        if (level === 0) {
          this.state.percent = 10;
        }
        callback(new Error("请输入含字母和数字的密码"));
      }
    },

    handlePasswordCheck(rule, value, callback) {
      let password = this.form.getFieldValue("password");
      if (value === undefined) {
        callback(new Error("请输入密码"));
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error("两次密码不一致"));
      }
      callback();
    },

    handlePasswordInputClick() {
      if (!this.isMobile()) {
        this.state.passwordLevelChecked = true;
        return;
      }
      this.state.passwordLevelChecked = false;
    },
    errTip(type) {
      this.$notification[type]({
        message: "验证失败",
        description: "请检查账户和验证码是否正确"
      });
    },
    handleSubmit() {
      let that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("提交");
          let tenantName = this.form.getFieldValue("tenantName");
          let username = this.form.getFieldValue("username");
          let verificationCode = this.form.getFieldValue("vrcode");
          if (tenantName == undefined) {
            tenantName = loginParamId;
          }
          this.$put("user/confirm", {
            tenantName: tenantName,
            userName: username,
            verificationCode: verificationCode
          })
            .then(r => {
              console.log("返回", r);
              if (r.data) {
                this.setUserName(username);
                this.setVerificationCode(verificationCode);
                this.setTenantName(tenantName);
                this.$router.push({ path: "/updatepassword" });
                window.clearInterval(that.interval)
                // this.successTip("success");
              } else {
                // console.log('验证失败')
                this.errTip("error");
              }
              // this.returnLogin();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    myInterVal() {
      let that = this;
      that.state.smsSendBtn = true;
      that.state.time--;
      sessionStorage.setItem("time", that.state.time);
      if (window.sessionStorage.getItem("time") <= 0) {
        window.clearInterval(that.interval);
      }
      if (that.state.time == 0) {
        that.state.time = 60;
        that.state.smsSendBtn = false;
        window.clearInterval(that.interval);
      }
    },
    getCaptcha(e) {
      e.preventDefault();
      let that = this;
      // that.interval = setInterval(that.myInterVal,1000);
      /* this.state.smsSendBtn = true;
      that.interval = window.setInterval(() => {
        that.state.time--;
        sessionStorage.setItem("time", that.state.time);
        if (that.state.time == 0) {
          that.state.time = 60;
          that.state.smsSendBtn = false;
          window.clearInterval(interval);
        }
      }, 1000); */
      this.form.validateFields(
        ["tenantName", "username", "mobile"],
        { force: true },
        (err, values) => {
          if (!err) {
            let tenantName = this.form.getFieldValue("tenantName");
            let name = this.form.getFieldValue("username");
            let phone = this.form.getFieldValue("mobile");
            if (tenantName == undefined) {
              tenantName = loginParamId;
            }
            /* sessionStorage.setItem("tenantName", tenantName);
            sessionStorage.setItem("username", name);
            sessionStorage.setItem("phone", phone); */
            this.$put("user/sendVerificationCode", {
              tenantName: tenantName,
              userName: name,
              phone: phone
            })
              .then(r => {
                that.interval = setInterval(that.myInterVal, 1000);
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      );
    },
    returnLogin() {
      this.$router.back(-1);
      window.clearInterval(this.interval);
      console.log(this.state.time);
    }
  },
  beforeRouteEnter: (to, from, next) => {
    console.log("from", from.name);
    if (from.name == "tenantLogin" || from.path == "/") {
      next(vm => {
        vm.showTenant = true;
      });
    } else {
      next(vm => {
        vm.showTenant = false;
      });
    }
  },
  created() {
    let that = this;
    console.log("created");
    let getTime = sessionStorage.getItem("time");
    if (getTime > 0) {
      that.state.time = getTime;
      that.interval = setInterval(that.myInterVal, 1000);
    } else {
      // window.clearInterval(that.interval)
      // console.log("00000");
    }
  },
  mounted() {
    console.log("mounted");
  },
  destroyed() {
    console.log("destroyed");
  }
};
</script>

<style lang="less" scoped>
.title {
  display: inline-block;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 15px;
}
.pass-leval {
  &.error {
    color: #ff0000;
  }
  &.warning {
    color: #ff7e05;
  }
  &.success {
    color: #52c41a;
  }
}
.user-layout-register {
  .ant-input-group-addon {
    &:first-child {
      background-color: #fff;
    }
  }
  & > h3 {
    font-size: 16px;
    margin-bottom: 20px;
  }
}

.vecode-box {
  display: flex;
  justify-content: space-between;
  .ant-row {
    width: 245px;
  }

  .btn-box {
    width: 175px;
    height: 40px;
    // background-color: pink;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    position: relative;
    .ant-btn-lg {
      width: 112px;
      padding: 0;
      font-size: 14px;
      height: 32px;
      border-color: #40a9ff;
      color: #40a9ff;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
.foot-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .commitbtn {
    width: 170px;
    border-color: #40a9ff;
    color: #40a9ff;
  }
  .canceltbtn {
    width: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/findpassword/findpassword.vue